export const alertsPaths = {
  absolute: '/:clientId/alerts-and-ai',

  tab: {
    absolute: '/:clientId/alerts-and-ai/:tab',
    relative: ':tab',
  },

  aiAnomaliesDetails: {
    absolute: '/:clientId/alerts-and-ai/ai-anomalies/:anomalyId',
    relative: 'ai-anomalies/:anomalyId',
  },

  alertDetails: {
    absolute: '/:clientId/alerts-and-ai/alert/:alertId',
    relative: 'alert/:alertId',
  },

  alertRules: {
    absolute: '/:clientId/alerts-and-ai/alert-rules',
    relative: 'alert-rules',
  },

  createAlertRules: {
    absolute: '/:clientId/alerts-and-ai/alert-rules/create',
    relative: 'alert-rules/create',
  },

  updateAlertRules: {
    absolute: '/:clientId/alerts-and-ai/alert-rules/:alertRuleId',
    relative: 'alert-rules/:alertRuleId',
  },
} as const;
